export default __webpack_public_path__ + "static/media/G.1861871f.svg";